export type ResponsiveProp<T> =
  | T
  | [T | null, T | null]
  | [T | null, T | null, T | null];

export function getResponsiveStyle<T, R>(
  styleValue: ResponsiveProp<T>,
  resolver: (item: T) => R
): ResponsiveProp<R> {
  if (Array.isArray(styleValue)) {
    return styleValue.map((item) =>
      item !== null ? resolver(item) : null
    ) as ResponsiveProp<R>;
  } else {
    return resolver(styleValue);
  }
}
